export default __webpack_public_path__ + "img/BB_RTK.09c7df036f57295ac23ac76be1f1ebdf.jpg";